module.exports = __webpack_public_path__ + "static/media/rounded-info-button.fdd734c7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/rounded-info-button.svg
// module id = 1804
// module chunks = 0